import { Modal } from "react-bootstrap";
import Popup from "../../Helpers/Popup/Popup";
import PopupTitle from "../../Helpers/Popup/PopupParts/PopupTitle";
import { useGetSpecificRequestQuery } from "../../../Redux/service/Requests/Request";
import { Tag } from "antd";
import trans from "../../../utils";
import Close from "../../Helpers/CloseBtn/Close";
import Loader from "../../Helpers/Loader/Loader";
import Button from "../../Helpers/Button/Button";
import ViewRequestBody from "./ViewRequestBody";
import { useContext } from "react";
import { popupcontext } from "../../../context/Popupscontext";

const ViewRequest = ({ requestId }) => {
	const { handleClose } = useContext(popupcontext);
	const { data, isFetching } = useGetSpecificRequestQuery(requestId, {
		skip: !requestId,
		refetchOnMountOrArgChange: true,
	});
  const statusColors = {
    inProgress: `blue`,
    pending: `orange`,
    completed: `green`,
    cancelled: `red`,
    none: `default`,
    Assigned: `purple`,
  };
	const request = data?.data || "";
	console.log("Request Data:", request);
	return (
		<Popup show={!!requestId} size={"lg"}>
			<Modal.Header className="modal-header flex-between">
				<Modal.Title id="contained-modal-title-vcenter">
					<PopupTitle
						headtitle={
							<div>
								{request?.serviceType || "Loading..."}{" "}
								{!isFetching && request?.status && (
									<Tag
										color={statusColors[request.status] || statusColors.none}
										className="text-capitalize"
									>
										{trans(request.status)}
									</Tag>
								)}
							</div>
						}
					/>
				</Modal.Title>
				<Close
					// eslint-disable-next-line react/style-prop-object
					style="close-32 close"
					close={() => handleClose("display")}
					img="Close"
				/>
			</Modal.Header>
			<Modal.Body className="modal-body-scrollable fixed-popup-height">
				{isFetching ? (
					<div className="loader-container">
						<Loader />
					</div>
				) : (
					<ViewRequestBody data={request} />
				)}
			</Modal.Body>
		</Popup>
	);
};

export default ViewRequest;
